// if you're using a bundler, first import:
import Headroom from "headroom.js";

// Überprüfen, ob das Element existiert
var element = document.querySelector(".headroom");
if (element) {
  // construct an instance of Headroom, passing the element
  var options = {
    // or you can specify offset individually for up/down scroll
    offset: {
      up: 40,
      down: 40
    },
    // or you can specify tolerance individually for up/down scroll
    tolerance: 5,
    // css classes to apply
    classes: {
      // when element is initialised
      initial: "headroom",
      // when scrolling up
      pinned: "headroom--pinned",
      // when scrolling down
      unpinned: "headroom--unpinned",
      // when above offset
      top: "headroom--top",
      // when below offset
      notTop: "headroom--not-top",
      // when at bottom of scroll area
      bottom: "headroom--bottom",
      // when not at bottom of scroll area
      notBottom: "headroom--not-bottom",
      // when frozen method has been called
      frozen: "headroom--frozen",
      // multiple classes are also supported with a space-separated list
      pinned: "headroom--pinned"
    },
  };
  // pass options as the second argument to the constructor
  // supplied options are merged with defaults
  var headroom = new Headroom(element, options);
  // initialise
  headroom.init();
}
